import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import DashboardProfile from '../../../shared/components/profile/DashboardProfile';
import { clientSideLinks } from '../clientRoutes';

function ClientProfilePage() {
  return (
    <DashboardShell role="CLIENT" sideLinks={clientSideLinks}>
      <DashboardProfile role="CLIENT" />
    </DashboardShell>
  );
}

export default ClientProfilePage;
